import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AssetDevicePositionUpdateDto, CurrentAssetLocationDto, AssetDeviceService, CustomerLocationDto, AssetDeviceVersusMovementDto, PagedListBaseModelOfAssetDevicePositionUpdateDto } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import * as moment from 'moment';
import { SummaryDataItemModel } from '../models/summary-data-item-model';
import { SessionStorageService } from '../services/session-storage.service';
import { LocationClassNameHelper, LocationTypeNames } from '../enums/LocationTypeNames';
import { Router } from '@angular/router';
import { GeoHelper } from '../helpers/geo';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
import { ContainerTypeSummary } from '../location-detail/container-type-summary';
import { FormControl } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { VehicleTypeHelper } from '../helpers/VehicleTypeHelper';
import { CustomerSettings } from '../services/customer-settings-service';

export enum InventryMode {
  All = 1,
  Individual
}

export class DropDownListItem {
  id: string;
  name: string;
}

@Component({
  selector: 'app-devices-component',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss']
})
export class DevicesComponent extends PagebaseComponent implements OnDestroy, OnInit {
  
  @ViewChild('mapdiv') 
  mapDiv: ElementRef;
  postions: AssetDeviceVersusMovementDto[];
  selectedRow: AssetDeviceVersusMovementDto = null;
  individualPositions: AssetDevicePositionUpdateDto[];
  
  // Private variables
  InventryMode = InventryMode;
  currentMode: InventryMode = InventryMode.All;
  mapZoomLevel: number;

  selectedVehicleType: string = null;

  private apiCall;

  // Public variables
  loading: boolean = true;

  // Map
  private map;
  private mapLayer = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}&key=AIzaSyBbtdwYOxBg-pnwcNSKmIw0O86uBHStozI', {
      maxZoom: 18,
      minZoom: 3,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
  });
  private drawLayer = L.layerGroup();

  // Constuctor
  constructor(
    private _assetDeviceService: AssetDeviceService,
    private sessionStorageService: SessionStorageService,
    private router: Router,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService,
    private customerSettings: CustomerSettings) {
    super(pageHelperService, applicationStatusService, customerSettings, "Inventory");
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  reset() {
    this.postions = [];
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }
  // Get the view data
  getData() {
    this.loading = true;
    this.setIsLoading(this.loading);
    this.apiCall = this._assetDeviceService.getAssetPositionsVersusMovement(this.pageHelperService.selectedCompanyId).subscribe(data => {
      this.postions = data
      this.loading = false;
      this.setIsLoading(this.loading);
      this.currentMode = InventryMode.All;
      this.initMap()
    }, error => {
      debugger;
    });
  }

  exportData() {
    this.loading = true;
    this.setIsLoading(this.loading);
    this.apiCall = this._assetDeviceService.getDevicesExport(this.pageHelperService.selectedCompanyId).subscribe(data => {
      this.loading = false;
      this.setIsLoading(this.loading);
      let filename = data.fileName;
      let blob: Blob = data.data;
      let a = document.createElement('a');
      a.download = filename;
      a.href = window.URL.createObjectURL(blob);
      a.click();
    }, error => {
      debugger;
    });
  }

  private getLocationsFromPositions(data: AssetDeviceVersusMovementDto[]): CustomerLocationDto[] {
    const locations: CustomerLocationDto[] = [];
    data.filter(device => device.yabbyLocation != null).forEach(device => {
      if (!locations.find(location => location.id == device.yabbyLocation.id)) {
        locations.push(device.yabbyLocation);
      }
    });

    return locations;
  }

  private getLocationsFromIndividualPositions(data: AssetDevicePositionUpdateDto[]): CustomerLocationDto[] {
    const locations: CustomerLocationDto[] = [];
    data.filter(device => device.location != null).forEach(device => {
      if (!locations.find(location => location.id == device.location.id)) {
        locations.push(device.location);
      }
    });

    return locations;
  }

  private initMap(): void {
    let allLatLons = [];
    this.postions.forEach(position => {
      allLatLons.push({ lat: position.latitude, lon: position.longitude })
    });

    var locations = this.getLocationsFromPositions(this.postions);
    locations.forEach(location => {
      allLatLons.push({ lat: location.latitude, lon: location.longitude })
    }); 
    
    let centre = GeoHelper.GetCenterFromPositions(allLatLons);
    
    if (!this.map) {
      let zoom = GeoHelper.CalculateZoom(allLatLons, this.mapDiv.nativeElement.offsetHeight, this.mapDiv.nativeElement.offsetWidth);
      this.map = L.map('map', {
        center: [ centre.lat, centre.lon ],
        zoom: zoom,
        scrollWheelZoom: false
      });

      this.mapLayer.addTo(this.map);
      this.drawLayer.addTo(this.map);
      setTimeout(() => {
        this.map.invalidateSize(true);
      }, 1)
    } else {
      this.map.flyTo(new L.LatLng(centre.lat, centre.lon), 15, {
        animate: true,
        duration: 1.5
      });
    }
    let ctrl = this;
    this.map.on('zoomend', function() {
      if (ctrl.mapZoomLevel != ctrl.map.getZoom()) {
        ctrl.mapZoomLevel = ctrl.map.getZoom();
        
        ctrl.drawLocations(false)
      }
    });

    this.drawLocations(true)
  }

  selectedVehicleTypeValueChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("dashboard-active-selectedVehicleType", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleType")
    }

    // this.showAssets(true);    
  }

  drawLocations(recentreMap: boolean) {
    console.log("draw")
    // Clear  and re add draw layer
    let allLatLons = [];
    this.map.removeLayer(this.drawLayer);
    this.drawLayer = L.layerGroup();
    this.drawLayer.addTo(this.map);
    
    let locations;
    if (this.currentMode == InventryMode.All) {
      locations = this.getLocationsFromPositions(this.postions);
      locations.forEach(location => {
          allLatLons.push({ lat: location.latitude, lon: location.longitude })
      });

      this.postions.filter(pos => pos.latitude != null).forEach(location => {
        allLatLons.push({ lat: location.latitude, lon: location.longitude })
      });    
    } else {
      locations = this.getLocationsFromIndividualPositions(this.individualPositions);
      locations.forEach(location => {
          allLatLons.push({ lat: location.latitude, lon: location.longitude })
      });

      this.individualPositions.forEach(location => {
        allLatLons.push({ lat: location.latitude, lon: location.longitude })
      });    
    }

    if (recentreMap) {
      let centre = GeoHelper.GetCenterFromPositions(allLatLons);
      let zoom = GeoHelper.CalculateZoom(allLatLons, this.mapDiv.nativeElement.offsetHeight, this.mapDiv.nativeElement.offsetWidth);
      zoom = allLatLons.length == 1 ? 12 : zoom;
      this.mapZoomLevel = zoom;
      this.map.flyTo(new L.LatLng(centre.lat, centre.lon), zoom, {
        animate: true,
        duration: 1.5
      });
    }

    locations.forEach(location => {
      let locationBins = this.getBinsAtLocation(location.id).map(a => a.asset);
      this.addLocationPin(location.id, location.locationType, location.displayName, location.latitude, location.longitude, locationBins);
    });   
    if (this.currentMode == InventryMode.All) {
      this.postions.filter(pos => pos.yabbyLocation == null && pos.latitude != null).forEach(location => {
        this.addAsset(location);
      });   
    } else {
      this.individualPositions.filter(pos => pos.location == null).forEach(location => {
        this.addAsset(location);
      });   
    }
  }

  getBinsAtLocation(locationId: string) : AssetDeviceVersusMovementDto[]{
    return this.postions.filter(a => a.yabbyLocation != null && a.yabbyLocation.id == locationId);
  }

  addAsset(asset) {
    let pinColour = '#fff';
    
    let radius = this.getLocationRadius(this.mapZoomLevel);

    let popupContent = '<p>' + asset.asset + '</p>';
    popupContent += '<p>' + asset.updateDateTime + '</p>';
    const popup = R.responsivePopup({ hasTip: false, autoPan: false, offset: [20, 20]}).setContent(popupContent);
    let marker = L.circle([asset.latitude, asset.longitude], { 
      radius: radius,
      color: "black",
      weight: 1,
      fillColor: pinColour,
      fillOpacity: 1,
     }).addTo(this.drawLayer);
    let showTip = function() {
      this.unbindTooltip();
      if(!this.isPopupOpen()) this.bindPopup(popup, { minWidth: 280}).openPopup();
    }
    
    let hideTip = function() {
      this.unbindTooltip();
      if(this.isPopupOpen()) this.closePopup();
    }
   
    marker.on('mouseover', showTip);
    marker.on('mouseout', hideTip);
  }

  addLocationPin(locationId, locationTypeName, locationName, locationLatitude, locationLongitude, locationBins: string[]) {
    let pinColour = locationTypeName == null ? "vehicle" : LocationClassNameHelper.getLocationColour(locationTypeName);
    
    let radius = this.getLocationRadius(this.mapZoomLevel);
    
    let popupContent = '<p><b>' + locationName + '</b></p>';
    locationBins.forEach(bin => {
      popupContent += '<p>' + bin + '</p>';
    })
    const popup = R.responsivePopup({ hasTip: false, autoPan: false, offset: [20, 20]}).setContent(popupContent);
    let marker = L.circle([locationLatitude, locationLongitude], { 
      radius: radius,
      color: "black",
      weight: 1,
      fillColor: pinColour,
      fillOpacity: 1,
     }).addTo(this.drawLayer);
    let showTip = function() {
      this.unbindTooltip();
      if(!this.isPopupOpen()) this.bindPopup(popup, { minWidth: 280}).openPopup();
    }
    
    let hideTip = function() {
      this.unbindTooltip();
      if(this.isPopupOpen()) this.closePopup();
    }
    
    let router = this.router;
    let goToRoute = function() {
      router.navigate([`/location/${locationId}`]);
    }

    marker.on('mouseover', showTip);
    marker.on('mouseout', hideTip);
    marker.on('click', goToRoute);
  }

  selectRow(item:AssetDeviceVersusMovementDto) {
    if (this.selectedRow && this.selectedRow.id == item.id) {
      this.selectedRow = null;
      this.currentMode = InventryMode.All;
    } else {
      this.selectedRow = item;
      this.currentMode = InventryMode.Individual;
    }

    this.refreshMap();
  }

  refreshMap() {
    if (this.currentMode == InventryMode.All) {
      this.individualPositions = [];
      this.drawLocations(true);
    } else {
      this.loading = true;
      this.setIsLoading(this.loading);
      this.apiCall = this._assetDeviceService.getAssetPositions(this.pageHelperService.selectedCompanyId, this.selectedRow.asset, 1, 100).subscribe(data => {
        this.individualPositions = data.items;
        this.loading = false;
        this.setIsLoading(this.loading);
        this.drawLocations(true);
      }, error => {
        debugger;
      });
    }
  }

  getLocationRadius(zoom: number) {
    switch(zoom) {
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
        return 2000;
      case 7:
        return 1500;
      case 8:
        return 1250;
      case 9:
        return 900;
      case 10:
        return 540;
      case 11: 
        return 324;
      case 12:
        return 194;
      case 13:
        return 116;
      case 14:
        return 70;
      case 15:
        return 42;
      case 16:
        return 25;
      case 17:
        return 15;
      default:
        return 10;
    }
  }
}